import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {StateService} from '../state/state.service';

@Injectable()
export class CacheInterceptor implements HttpInterceptor {

  constructor(
    private readonly _stateService: StateService,
  ) {
  }

  // not called directly, but called by framework on each http request from http client
  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.isAsset(request)) {
      return next.handle(request);
    }
    return next.handle(request.clone({
      params: request.params.set('version', this._stateService.appVersion),
    }));
  }

  private isAsset(request: HttpRequest<any>): boolean {
    return request.url.includes('assets/');
  }

}
